import { useQuery } from '@tanstack/react-query';
import { getCoachInsight } from '../services/anthropic';
import { useFitnessStore } from '../store/fitnessStore';
import { useAILimit } from './useAccess';

export function useAICoach(screen) {
  const profile = useFitnessStore((s) => s.profile);
  const workoutHistory = useFitnessStore((s) => s.workoutHistory);
  const incrementAIUsage = useFitnessStore((s) => s.incrementAIUsage);
  const { canUse } = useAILimit('coach');

  return useQuery({
    queryKey: ['coach', screen, profile.subscriptionTier, profile.weight, profile.fitnessLevel],
    queryFn: async () => {
      if (!canUse && profile.subscriptionTier === 'free') {
        return {
          insight: 'You\'ve used your 3 free AI coach messages today. Upgrade for unlimited coaching.',
          action: 'Come back tomorrow or upgrade to Pro.',
          emoji: '🔒',
        };
      }
      const result = await getCoachInsight({ profile, recentWorkouts: workoutHistory, screen });
      incrementAIUsage('coach');
      return result;
    },
    staleTime: 1000 * 60 * 10,
    retry: 1,
    placeholderData: {
      insight: 'Every rep counts. Your consistency is building something extraordinary.',
      action: 'Complete today\'s planned session with full focus.',
      emoji: '🔥',
    },
  });
}
